import React from "react";
import { ArrowUpRight } from "lucide-react";
import {Link} from 'react-router-dom'

export default function Portfolio() {
  return (
    <section className="w-full py-12 md:py-12 px-4 sm:px-6 lg:px-8 bg-[#ffffff]">
      <div className="max-w-7xl mx-auto">
      
        {/* Header */}
        <div className="mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-4xl  text-center font-semibold leading-tight mb-6" style={{ color: "#000000" }}>
            PT KCS Infor Consulting Services Portfolio
          </h2>
            {/* <p
              className="text-base sm:text-lg leading-relaxed mb-8 font-normal text-center"
              style={{ color: "#000000", wordBreak: 'normal',overflowWrap: 'normal',hyphens: 'none',whieSpace: 'normal' }}
            >
            Be Part of Infor Consulting Services' Growing Delivery Team
          </p> */}
        </div>

        {/* Content and Image - Side by Side */}
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          
          {/* Left: Content - 50% width */}
          <div className="lg:w-1/2">
            <div className="space-y-8">
              <div>
                <h3 className="text-lg md:text-xl font-semibold mb-3" style={{ color: "#000000" }}>
                  End-to-End System Implementation
                </h3>
            <p
              className="text-base sm:text-lg leading-relaxed mb-8 font-normal"
              style={{ color: "#000000", wordBreak: 'normal',overflowWrap: 'normal',hyphens: 'none',whieSpace: 'normal' }}
            >
                  Full-cycle ERP deployment from planning through go-live. We manage every phase — scoping, 
                  configuration, data migration, testing, and training — so your team transitions without disruption.
                </p>
              </div>
              
              <div>
                <h3 className="text-lg md:text-xl font-semibold mb-3" style={{ color: "#000000" }}>
                  Strategic Process Consulting
                </h3>
            <p
              className="text-base sm:text-lg leading-relaxed mb-8 font-normal"
              style={{ color: "#000000", wordBreak: 'normal',overflowWrap: 'normal',hyphens: 'none',whieSpace: 'normal' }}
            >
                  Expert guidance to align Infor capabilities with your unique business workflows. We map your 
                  operations, identify gaps, and design a solution blueprint built for long-term scalability.
                </p>
              </div>
              
              <div>
                <h3 className="text-lg md:text-xl font-semibold mb-3" style={{ color: "#000000" }}>
                  24/7 Managed Support Services
                </h3>
            <p
              className="text-base sm:text-lg leading-relaxed mb-8 font-normal"
              style={{ color: "#000000", wordBreak: 'normal',overflowWrap: 'normal',hyphens: 'none',whieSpace: 'normal' }}
            >
                  Round-the-clock monitoring, maintenance, and helpdesk for uninterrupted operations. Our dedicated 
                  team ensures your systems run at peak performance every hour of every day.
                </p>
              </div>
{/* 
            <Link
                to=""
                className="bg-[#0D5EF4] hover:bg-[#004b82]
                text-white font-semibold px-10 py-4
                transition-all duration-300"
              >
                Learn More
              </Link> */}
            </div>
          </div>

          {/* Right: Image - 50% width */}
          <div className="lg:w-1/2 flex items-start justify-center">
            <img
              src="https://ik.imagekit.io/7wqj9br0b/Infor/Infor_Services_Offerings.png?updatedAt=1736999085606"
              alt="Infor Consulting Services Portfolio Infographic"
              className="w-full max-w-[600px] h-auto object-contain"
              style={{ minHeight: "400px" }}
            />
          </div>

        </div>
      </div>
    </section>
  );
}